import type { FilterRuleModel } from '../generated'

import {
	createParser,
	parseAsInteger,
	parseAsString,
	parseAsStringLiteral,
	useQueryStates,
} from 'nuqs'

import { decodeComplexQuery, encodeComplexQuery } from '@/shared/tools/location'

const parseAsFilters = createParser({
	parse(queryValue) {
		return decodeComplexQuery(queryValue)?.filters || []
	},
	serialize(value) {
		return encodeComplexQuery({ filters: value }) || ''
	},
})
const parseAsSorting = createParser({
	parse(queryValue) {
		if (queryValue === '') return null

		return queryValue.split(',').map((str) => {
			const [key = '', direction = ''] = str.split(':')
			const desc =
				parseAsStringLiteral(['asc', 'desc']).parse(direction) ?? 'asc'

			return {
				id: key,
				desc: desc === 'desc',
			}
		})
	},
	serialize(value) {
		if (value.length === 0) return null as any

		return value
			.map(({ id, desc }) => `${id}:${desc ? 'desc' : 'asc'}`)
			.join(',')
	},
})
const defaultFilter: FilterRuleModel[] = []
// Module-level: nuqs >=2.10 compares defaults by reference (parser eq is ===)
const defaultSorting: { id: string; desc: boolean }[] = []

export const useLocationQuery = () =>
	useQueryStates(
		{
			// pagination params
			limit: parseAsInteger.withDefault(100),
			offset: parseAsInteger.withDefault(0),

			// text search params
			search: parseAsString.withDefault(''),

			// text encoded filters
			filters: parseAsFilters.withDefault(defaultFilter),

			// sorting params
			sorting: parseAsSorting.withDefault(defaultSorting),

			// selected item params
			selected: parseAsString.withDefault(''),
		},
		{
			history: 'push',
			urlKeys: {
				filters: 'qf',
				search: 'q',
			},
		}
	)
